import { useEffect } from 'react'

type OverlayCallback = (hasOpenOverlays: boolean) => void

let openCount = 0
let callback: OverlayCallback | null = null
let generation = 0

/** Called by MobileCommonStore to subscribe. Returns unsubscribe fn. */
export function onOverlayChange(cb: OverlayCallback): () => void {
  callback = cb
  return () => {
    callback = null
  }
}

/** Called by overlay components when opening. Returns a close fn (guaranteed pairing). */
export function notifyOverlayOpen(): () => void {
  let closed = false
  const capturedGeneration = generation
  openCount++
  if (openCount === 1) {
    callback?.(true)
  }

  return () => {
    if (closed || capturedGeneration !== generation) return
    closed = true
    openCount = Math.max(0, openCount - 1)
    if (openCount === 0) {
      callback?.(false)
    }
  }
}

/** Hook for functional components. Notifies while isOpen is true. */
export function useOverlayNotifier(isOpen: boolean): void {
  useEffect(() => (isOpen ? notifyOverlayOpen() : undefined), [isOpen])
}

/** Safety net — resets count to 0 and shows navbar. Called on route change. */
export function resetOverlays(): void {
  if (openCount === 0) return
  openCount = 0
  generation++
  callback?.(false)
}
